export default __webpack_public_path__ + "static/media/icon_campanha_gray.aab0208e.svg";